import React from 'react';
import UpsellCard from './UpsellCard';
import { groupAddOnsBySubCategory } from '../../../helpers/upsellHelpers';
import useWheelHorizontalScroll from '../../../hooks/useWheelHorizontalScroll';

const AddOnSection = ({ label, addOns, selectedAddOnIds, onToggleAddOn, isTabletScreen }) => {
  if (!addOns || addOns.length === 0) return null;

  const scrollRef = useWheelHorizontalScroll();

  const grouped = groupAddOnsBySubCategory(addOns);
  const groupEntries = Object.entries(grouped);
  const hasMultipleGroups = groupEntries.length > 1;

  return (
    <div className="upsell-section">
      {isTabletScreen ?
        <h3 className="upsell-section__label">{label}</h3> :
        <h2 className="customise-section-header">{label}</h2>
      }
      <div className="upsell-section__scroll-container" ref={scrollRef}>
        {groupEntries.map(([subCategoryName, products]) => (
          <React.Fragment key={subCategoryName}>
            {hasMultipleGroups && (
              <div className="upsell-section__group-divider">
                <span className="upsell-section__group-divider-text">{subCategoryName}</span>
                <div className="upsell-section__group-divider-items">
                  {products.map(product => {
                    const isSelected = selectedAddOnIds.includes(product.id);
                    return (
                      <UpsellCard
                        key={product.id}
                        product={product}
                        isSelected={isSelected}
                        onSelect={() => onToggleAddOn(product)}
                        isTabletScreen={isTabletScreen}
                      />
                    );
                  })}
                </div>
              </div>
            )}
            {!hasMultipleGroups && products.map(product => {
              const isSelected = selectedAddOnIds.includes(product.id);
              return (
                <UpsellCard
                  key={product.id}
                  product={product}
                  isSelected={isSelected}
                  onSelect={() => onToggleAddOn(product)}
                  isTabletScreen ={isTabletScreen}
                />
              );
            })}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default AddOnSection;
